import { Box, HStack, Image, VStack } from "native-base";
import React from "react";
import CmsLoginPageCard from "../../../../containers/cmsLoginPageCards";
import "../../web/style.css";
import Logo from "../../../../utils/logo";

const CmsLoginPageWeb = () => {
  return (
    <HStack flex={1} w="100%" minH={"100vh"}>
      <VStack w="50%">
        <Box pl={60} pt={60}>
          <Logo w="272px" h="75px" />
        </Box>

        <Box>
          <CmsLoginPageCard pl="60px" pr="200px" />
        </Box>
      </VStack>

      <div className="login-image">
        <div
          className="login-image-container"
          style={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "4%",
            paddingLeft: "5%",
          }}
        >
          <Box px={10} py={30} w={"80%"} h={"80%"}>
            <Image
              source={{
                uri: require("../../../../utils/quickLinkImages/Travel insurance-pana 1.png"),
              }}
              alt="image"
              width={"90%"}
              height={"100%"}
              loading="lazy"
            />
          </Box>
        </div>
      </div>
    </HStack>
  );
};

export default CmsLoginPageWeb;
